var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { staticClass: "justify-center", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "soli-grey py-0 justify-center font-weight-bold",
                    },
                    [_vm._v(_vm._s(_vm.getTitle))]
                  ),
                  _vm._v(" "),
                  this.$page.props.guest
                    ? _c(
                        "div",
                        { staticClass: "flex justify-center" },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "max-height": "400",
                                "min-width": "375",
                                "content-class": "white",
                                "offset-y": "",
                                auto: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "soli-grey caption text-capitalize",
                                                attrs: {
                                                  rounded: "",
                                                  text: "",
                                                  "x-small": "",
                                                  color: "dark",
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              _vm._s(_vm.timezoneForm.timezone)
                                            ),
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  right: "",
                                                  "x-small": "",
                                                  color: "secondary",
                                                },
                                              },
                                              [_vm._v("keyboard_arrow_down")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2893167745
                              ),
                              model: {
                                value: _vm.timezoneMenu,
                                callback: function ($$v) {
                                  _vm.timezoneMenu = $$v
                                },
                                expression: "timezoneMenu",
                              },
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-list-item-group",
                                    {
                                      on: {
                                        change: function ($event) {
                                          return _vm.submitTimezone()
                                        },
                                      },
                                      model: {
                                        value: _vm.timezoneForm.timezone,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.timezoneForm,
                                            "timezone",
                                            $$v
                                          )
                                        },
                                        expression: "timezoneForm.timezone",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item",
                                        { attrs: { value: _vm.guessTz } },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              "Recommended:\n                                        " +
                                                _vm._s(_vm.guessTz)
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.timezones,
                                        function (timezone, idx) {
                                          return _c(
                                            "v-list-item",
                                            {
                                              key: idx,
                                              attrs: { value: timezone },
                                            },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(_vm._s(timezone)),
                                              ]),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "v-card-subtitle",
                        {
                          staticClass:
                            "soli-grey caption flex justify-center pb-0 pt-4",
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { "x-small": "", color: "dark" },
                            },
                            [_vm._v("public")]
                          ),
                          _vm._v(_vm._s(_vm.timezoneForm.timezone)),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading && !_vm.getEvents.length
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto my-3",
            attrs: {
              "max-width": "300",
              type: "list-item, list-item, list-item",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { justify: "center", "no-gutters": "" } },
        [
          !_vm.getEvents.length && !_vm.loading
            ? _c(
                "v-col",
                {
                  staticClass: "my-8 pa-3",
                  attrs: {
                    cols: "12",
                    sm: _vm.getStartedContext ? 8 : false,
                    md: _vm.getStartedContext ? 6 : false,
                  },
                },
                [
                  _vm.getStartedContext
                    ? _c(
                        "v-card",
                        {
                          staticClass: "soli-round pa-3",
                          staticStyle: { border: "3px solid #228cbd" },
                          attrs: { flat: "", outlined: "" },
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass:
                                "soli-grey pt-0 justify-center font-weight-bold",
                            },
                            [_vm._v("Don't Panic!")]
                          ),
                          _vm._v(" "),
                          _c("v-card-subtitle", { staticClass: "soli-grey" }, [
                            _vm._v(
                              _vm._s(`I'm sure we can find something for you! Take a look
                    around at any other nearby Musicologie using the filters
                    above, or contact us for help${
                      _vm.getStartedContext
                        ? ` getting
                    started.`
                        : "."
                    }`) + "\n                "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-slide-group",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loading || _vm.getEvents.length,
                  expression: "!loading || getEvents.length",
                },
              ],
              ref: "scrollDate",
              attrs: {
                "center-active": "",
                mandatory: "",
                "show-arrows": _vm.$vuetify.breakpoint.smAndUp,
              },
              model: {
                value: _vm.selectedEvent,
                callback: function ($$v) {
                  _vm.selectedEvent = $$v
                },
                expression: "selectedEvent",
              },
            },
            _vm._l(_vm.getEvents, function (event, idx) {
              return _c("v-slide-item", {
                key: idx,
                attrs: { value: _vm.globalMomentDate(event) },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ active, toggle }) {
                        return [
                          _c(
                            "v-btn",
                            {
                              staticClass: "round mx-1 my-2",
                              class: {
                                "shadow-blue": active,
                                "ml-3": idx == 0,
                                "mr-3": idx == _vm.getEvents.length - 1,
                              },
                              attrs: {
                                loading: active && _vm.intervalsLoading,
                                color: active ? "primary" : "dark",
                                small: "",
                                text: !active,
                                height: "55",
                                width: "55",
                              },
                              on: { click: toggle },
                            },
                            [
                              _c("div", { staticClass: "flex-col" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "font-weight-black subtitle-1",
                                    staticStyle: { "line-height": "20px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.globalMomentDay(event)) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "font-weight-bold",
                                    staticStyle: { "text-transform": "none" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.globalMomentWeekDayShort(event)
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _vm.loading && _vm.getEvents.length
            ? _c("v-skeleton-loader", {
                staticClass: "mx-auto my-5",
                attrs: {
                  "max-width": "350",
                  type: "list-item-avatar-three-line",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading && !_vm.selectedTeacher && _vm.getEvents.length
            ? _c(
                "v-row",
                { staticClass: "mt-1 justify-center" },
                _vm._l(_vm.intervals, function (intervalGroup, idx) {
                  return _c(
                    "v-col",
                    {
                      key: intervalGroup.teacher.id,
                      staticClass: "flex justify-center",
                      staticStyle: {
                        "min-width": "390px",
                        "max-width": "400px",
                      },
                      attrs: { cols: "12", sm: "6", md: "4", lg: "3" },
                    },
                    [
                      _c("TeacherAvatarCard", {
                        attrs: {
                          expand: "",
                          teacher: intervalGroup.teacher,
                          selectedInstrument: _vm.selectedInstrument,
                          intervalGroup: intervalGroup.intervals,
                          loading: _vm.loading,
                          disabled: "",
                          simStudentView: _vm.simStudentView,
                          hideDivider: idx == _vm.intervals.length - 1,
                          floating: _vm.floating,
                          value: _vm.value,
                        },
                        on: {
                          inputTime: function ($event) {
                            return _vm.$emit("inputTime", {
                              teacher: $event.teacher,
                              assignment_id: $event.assignment_id,
                              time: $event.time,
                            })
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading && _vm.selectedTeacher && _vm.getEvents.length
            ? _c(
                "v-row",
                { staticClass: "mt-1 justify-center" },
                _vm._l(_vm.intervals, function (intervalGroup) {
                  return _c(
                    "v-col",
                    { key: intervalGroup.teacher.id },
                    _vm._l(intervalGroup.intervals, function (ints) {
                      return _c(
                        "div",
                        { key: ints.assignment_id },
                        [
                          _vm.selectedTeacher
                            ? _c("SoliTime", {
                                ref: "soliTime",
                                refInFor: true,
                                attrs: {
                                  label: "Start Time",
                                  narrow: _vm.$vuetify.breakpoint.xs,
                                  teacher: intervalGroup.teacher,
                                  selectedInstrument: _vm.selectedInstrument,
                                  intervals: ints.openTimes,
                                  assignment_id: ints.assignment_id,
                                  loading: _vm.loading,
                                  select: false,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.$emit("inputTime", {
                                      teacher: intervalGroup.teacher,
                                      assignment_id: ints.assignment_id,
                                      time: $event,
                                    })
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.membershipEndAlert
            ? _c("SoliChoice", {
                attrs: {
                  title: "Sorry!",
                  subtitle: `There are no available options before your membership ends on ${_vm.globalMomentDateDots(
                    _vm.membershipEndAlert
                  )}.`,
                  button1: "Okay",
                },
                on: {
                  reset: function ($event) {
                    _vm.membershipEndAlert = null
                  },
                  option1: function ($event) {
                    return _vm.$emit("reset")
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$page.component == "MySchedule" && _vm.selectedTeacher
        ? _c(
            "v-card",
            {
              staticClass: "soli-round ma-3",
              staticStyle: { overflow: "hidden" },
              attrs: { flat: "", outlined: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("somethingNew", true)
                },
              },
            },
            [
              _c("v-card-subtitle", [
                _vm._v(
                  "\n            Can't find something that works?\n            "
                ),
                _c("u", { staticClass: "soli-link" }, [
                  _vm._v("Try something new"),
                ]),
                _vm._v(
                  " by booking with a\n            different teacher, or on a different instrument\n        "
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }